export default __webpack_public_path__ + "static/media/wife-and-cat.65702c1a.jpg";